import { useDebounce } from '@faks/shared';
import { type Dispatch, type SetStateAction, useState } from 'react';

export const useSearchState = (): [string, Dispatch<SetStateAction<string>>, string] => {
  const [search, setSearch] = useState('');
  const searchDebounced = useDebounce(search);

  return [search, setSearch, searchDebounced];
};
